export default "__VITE_ASSET__Bus6JarX__"